import { render, staticRenderFns } from "./deleteInspectionPoint.vue?vue&type=template&id=2773f649&scoped=true"
import script from "./deleteInspectionPoint.vue?vue&type=script&lang=js"
export * from "./deleteInspectionPoint.vue?vue&type=script&lang=js"
import style0 from "./deleteInspectionPoint.vue?vue&type=style&index=0&id=2773f649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2773f649",
  null
  
)

export default component.exports